module.exports = {"321084001":"高邮街道","321084101":"龙虬镇","321084106":"汤庄镇","321084107":"卸甲镇","321084108":"三垛镇","321084109":"甘垛镇","321084112":"界首镇","321084113":"周山镇","321084115":"临泽镇","321084116":"送桥镇","321084200":"菱塘回族乡","321084401":"城南经济新区（车逻镇）","321084406":"经济开发区（马棚街道）"}


//////////////////
// WEBPACK FOOTER
// ./src/town/321084.json
// module id = 1020
// module chunks = 0